import { ReactElement } from "react"
import * as S from './spinner-style'

export function Spinner (): ReactElement {
  return <S.Container>Carregando...</S.Container>
}